"use strict";

exports.__esModule = true;
// Use children as fallback if the passed item is null
var FallbackRender = exports.FallbackRender = function FallbackRender(_ref) {
  var item = _ref.item,
      children = _ref.children;
  return item || children;
};

exports.default = FallbackRender;